import { ApiService } from '../../app-lite/api/api.service';
import { TableService }  from '../../app-lite/table/table.service';

import DealershipAdvertisingSettingsHtml from './dealership.advertising-settings.html';
import DealershipSaleHtml                from './dealership.sale.html';
import DealershipSettingsHtml            from './dealership.settings.html';
import DealershipTemplateHtml            from './dealership.template.html';
import DealershipTemplatesHtml           from './dealership.templates.html';
import DealershipTransactionCenterHtml   from './dealership.transaction-center.html';

export function DealershipStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    abstract: true,
    name    : 'app.dealership',
    url     : '/dealership'
  })
  .state({
    controller: 'DealershipSettingsCtrl',
    name      : 'app.dealership.settings',
    params    : {
      activated: { squash: true, value: null }
    },
    templateUrl: DealershipSettingsHtml,
    url        : '/settings/:activated',
    resolve    : {
      company   : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company'),
      dealership: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/dealership_setting')
    }
  })
  .state({
    controller: 'DealershipAdvertisingSettingsCtrl',
    name      : 'app.dealership.advertising-settings',
    params    : {
      activated: { squash: true, value: null }
    },
    templateUrl: DealershipAdvertisingSettingsHtml,
    url        : '/advertising_settings/:activated',
    resolve    : {
      company    : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company'),
      advertising: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/dealership_advertising_setting')
    }
  })
  .state({
    controller: 'DealershipSaleCtrl',
    name      : 'app.dealership.sale',
    params    : {
      customer_id: { squash: true, value: null },
      id         : { squash: true, value: null }
    },
    templateUrl: DealershipSaleHtml,
    url        : '/:customer_id/sale/:id',
    resolve    : {
      invoiceTypes  : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/unit_sale_invoice_types', null, 'invoiceTypes'),
      paymentMethods: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/invoice_payment_methods'),
      paymentTerms  : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('system/payment_term_types', null, 'paymentTerms'),
      taxGroups     : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/tax_groups'),
      vehicleSale   : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/dealership_setting/vehicle_sale_product'),
      vehicleTradeIn: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/dealership_setting/trade_in_product'),
      credits       : ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> =>
        $stateParams.id
          ? workshopAPI.get('credit_application_items/invoice_credit_list', [$stateParams.id, 0, 6])
          : [],
      customer: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | null =>
        $stateParams.customer_id
          ? workshopAPI.get('/customer', $stateParams.customer_id)
          : null,
      defaultTaxGroup: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | null =>
        $stateParams.customer_id
          ? workshopAPI.get('/tax_groups/default_for_customer', $stateParams.customer_id)
          : null,
      invoice: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | null =>
        $stateParams.id
          ? workshopAPI.get('/invoice', $stateParams.id)
          : null,
      payments: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> =>
        $stateParams.id
          ? workshopAPI.get('/invoices/payments_for_invoice_list', [$stateParams.id, 0, 6, 'post_date', 'desc'])
          : [],
    }
  })
  .state({
    controller: 'DealershipTemplateCtrl',
    name      : 'app.dealership.template',
    params    : {
      id: { squash: true, value: null }
    },
    templateUrl: DealershipTemplateHtml,
    url        : '/template/:id',
    resolve    : {
      bodyTypes        : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/vehicle_body_types/', null, 'bodyTypes'),
      company          : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company'),
      driveTypes       : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/drive_types/', null, 'driveTypes'),
      franchises       : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/vehicle_group_or_franchise_types'),
      fuelTypes        : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/fuel_types/', null, 'fuelTypes'),
      transmissionTypes: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/transmission_types/', null, 'transmissionTypes'),
      template         : ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : any | ng.IPromise<any> =>
        $stateParams.id
          ? workshopAPI.get('/vehicle_template', $stateParams.id)
          : {},
    }
  })
  .state({
    controller : 'DealershipTemplatesCtrl',
    name       : 'app.dealership.templates',
    templateUrl: DealershipTemplatesHtml,
    url        : '/templates',
    resolve    : {
      templates: ( tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> => {
        const cache = tableApi.getCacheForTable('dealershipTemplates');

        return workshopAPI.get('/vehicle_templates', [
          0,
          cache.paging.pageSize   || 10,
          cache.sorting.field     || 'find_description',
          cache.sorting.direction || 'asc'
        ]);
      }
    }
  })
  .state({
    controller : 'DealershipTransactionCenterCtrl',
    name       : 'app.dealership.transaction-center',
    templateUrl: DealershipTransactionCenterHtml,
    url        : '/transaction_center',
    resolve    : {
      constraints : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/dealership_job_filter_constraint_types'),
      invoiceTypes: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/dealership_job_invoice_types'),
      transactions: ( tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> => {
        const cache = tableApi.getCacheForTable('dealershipTransactionCenter');

        return workshopAPI.stream('/dealership_job_center', [
          cache.filtering.value ? cache.filtering.value : '*',
          0,
          cache.paging.pageSize   || 11,
          cache.filtering.post_date       ? cache.filtering.post_date       : '*',
          cache.filtering.constraint_type ? cache.filtering.constraint_type : '*',
          cache.filtering.invoice_type    ? cache.filtering.invoice_type    : '*',
          cache.sorting.field     || 'invoice.post_date',
          cache.sorting.direction || 'desc'
        ]);
      }
    }
  });
};